export * from '@modules/AiTriage/consts/aiTriage.consts';
